<template>
  <header>
    <div class="payment-dutch__title">
      <figure class="header__figure">
        <img src="@/assets/images/icon-dutch.svg" alt="아이콘" />
      </figure>
      <h1>
        <span class="title__line">
          <span class="title__typography">{{ t('title.dutch') }}</span>
        </span>
      </h1>
    </div>
    <div class="payment-dutch__tab-area">
      <ul class="payment-dutch__tabs list-style-none">
        <li>
          <span
            :class="{
              active: type === 'menu',
              disabled: !canPageMove,
            }"
            @mouseup="handleMenuTabClick"
            @touchend.prevent="handleMenuTabClick"
            >{{ t('title.menu_divide') }}</span
          >
        </li>
        <li>
          <span
            :class="{
              active: type === 'amount',
              disabled: !canPageMove,
            }"
            @mouseup="handleAmountTabClick"
            @touchend.prevent="handleAmountTabClick"
            >{{ t('title.amount_divide') }}</span
          >
        </li>
      </ul>
    </div>
  </header>
</template>

<script setup lang="ts">
  import PaymentDutchAmount from '@/components/PaymentDutchAmount.vue';
  import PaymentDutchMenu from '@/components/PaymentDutchMenu.vue';
  import { useModalStore } from '@/stores/modal';
  import { useOrderStore } from '@/stores/order';
  import { usePaymentStore } from '@/stores/payment';
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  defineProps<{ type: 'menu' | 'amount' }>();

  const { t } = useI18n();
  const modalStore = useModalStore();
  const orderStore = useOrderStore();
  const paymentStore = usePaymentStore();

  // 메뉴 나눔 페이지로 이동 가능 여부 (선주문 후결제인 경우, 결제 완료된 금액이 한개라도 있다면 이동 불가)
  const canPageMove = computed(() => !orderStore.isPreOrder && paymentStore.summary.splits.length === 0);

  const handleMenuTabClick = () => {
    if (!canPageMove.value) return;
    modalStore.openFullScreenModal(PaymentDutchMenu, {}, true);
  };

  const handleAmountTabClick = () => {
    // 결제 완료된 메뉴 나눔이 한개라도 있다면 금액 나눔 페이지로 이동 못하게 막기
    if (!canPageMove.value) return;
    modalStore.openFullScreenModal(PaymentDutchAmount, {}, true);
  };
</script>

<style scoped lang="scss">
  @use '@/assets/scss/variables' as vars;

  header {
    grid-column: 1 / 4;
    display: flex;
    align-items: flex-end;
    border-bottom: 0.0746vw solid var(--border-color-secondary);
    .payment-dutch__title {
      display: flex;
      align-items: center;
      margin-bottom: 1.194vw;
      margin-right: 2.2388vw;
      .header__figure {
        width: 2.6866vw;
        margin-right: 0.7463vw;
        line-height: 1;
        @media (max-width: vars.$md) {
          width: 18px;
        }
        img {
          width: 100%;
        }
      }
      h1 {
        font-size: 2.0896vw;
        font-weight: 700;
        @media (max-width: vars.$md) {
          font-size: 18px;
        }
      }
    }
    .payment-dutch__tab-area {
      //width: calc(100% - 27.0896vw);
      .payment-dutch__tabs {
        display: flex;

        li {
          padding: 0 4.4776vw;
        }
        span {
          display: block;
          font-size: 1.7164vw;
          font-weight: 400;
          padding-bottom: 0.8955vw;
          border-bottom: 0.1493vw solid transparent;
          @media (max-width: vars.$md) {
            font-size: 14px;
          }
        }
        span.active {
          font-weight: 700;
          color: var(--brand-primary);
          border-bottom: 0.3731vw solid var(--brand-primary);
        }
        span.disabled {
          opacity: 0.5;
        }
      }
    }
  }
</style>
